import { Tooltip, TooltipProps } from 'antd'
import { isFunction } from 'lodash-es'
import { FunctionComponent, ReactNode } from 'react'
import { useIntl } from '@/i18n/hooks/use-intl'

type PermissionInsufficientTooltipProps = TooltipProps & {
  insufficient: boolean
}

const PermissionInsufficientTooltip: FunctionComponent<
  PermissionInsufficientTooltipProps
> = ({ insufficient, title, children, ...otherProps }) => {
  const { formatMessage } = useIntl()

  return (
    <Tooltip
      {...otherProps}
      title={((): ReactNode => {
        if (insufficient) {
          return formatMessage({
            id: 'workspace:insufficient_permission_tooltip',
          })
        }

        return isFunction(title) ? title() : title
      })()}
    >
      {children}
    </Tooltip>
  )
}

export default PermissionInsufficientTooltip
